import { z } from 'zod';

export namespace GetTerritories {
  export const Schema = {
    Query: z.object({
      q: z.string().optional(),
    }),
    Response: z.object({
      items: z.array(
        z.object({
          id: z.uuid(),
          name: z.string(),
          territoryKey: z.string(),
        })
      ),
    }),
  };

  export type Request = z.infer<typeof Schema.Query>;
  export type Response = z.infer<typeof Schema.Response>;
}

const territoryUpsertItemSchema = z.object({
  territoryKey: z.string().trim().min(1),
  name: z.string().trim().min(1),
});

export namespace UpsertTerritories {
  export const Schema = {
    Body: z.object({
      items: z.array(territoryUpsertItemSchema).min(1),
    }),
  };

  export type Request = z.infer<typeof Schema.Body>;
}
